import {useTranslation} from 'react-i18next';
import * as css from './AutomatedLead.css';
import * as leadsIcons from '../../assets/symbols/symbols/leadsIcons'; 
import {formatNumber} from '../../library/numberFunction';
import store from '../../store';
import {getTickdataLeads, getWhatsappLeads, getLivePromotionLeads} from '../../redux/publish/leadActions';
import useShow from '../../hooks/useShow';
import {useSelector} from 'react-redux';
import WhatsappLeadDetails from './leadsDetails/whatsappLeadDetails/whatsappLeadDetails';
import TickdataCampaignsDetails from './leadsDetails/tickdataCampaignsDetails/tickdataCampaignsDetails';
import LivePromotionDetails from './leadsDetails/livePromotionDetails/livePromotionDetails';

const LEAD_TYPES = {
    TICKDATA: 'TICKDATA',
    WHATSAPP: 'WHATSAPP',
    WHATSAPP_PROMOTION: 'WHATSAPP_PROMOTION',
    LIVE: 'LIVE',
};

export function AutomatedLeadDetail({type,lead}) {
    const {t} = useTranslation('publish');
    return (
        <css.container data-cy="leadDetail">
            <css.boldText>{t(type)}</css.boldText>
            <css.text>{formatNumber(lead[type])} {type==='totalPrice' && store.getState().event.currencySymbol}</css.text>
        </css.container>
    );
}

export function AutomatedLead({lead}) {
    const {t} = useTranslation('publish');
    const isMaster = useSelector(state => state.user?.isMaster);
    const leadDetails = ['totalPrice','transactions','tickets'];
    const {title,name}= lead;
    const {isOpen, open, close, showClass} = useShow();

    const clickableLeads = [LEAD_TYPES.TICKDATA, LEAD_TYPES.WHATSAPP_PROMOTION, LEAD_TYPES.LIVE];
    const handleClick = () => {
        if(name===LEAD_TYPES.TICKDATA && isMaster){
            getTickdataLeads();
            open();
        } else if(name===LEAD_TYPES.WHATSAPP_PROMOTION && isMaster){
            getWhatsappLeads();
            open();
        } else if(name===LEAD_TYPES.LIVE && isMaster){
            getLivePromotionLeads();
            open();
        }
    };

    return (
        <>
            <css.wrapper $clickable={clickableLeads.includes(name)} onClick={handleClick} data-cy="automatedLead">
                <css.icon icon={(leadsIcons[name.toLowerCase()])} className={title}>
                    <css.title className={`${name}  ${title==='frontpage'&&'main'}`}>{t(title)}</css.title>
                </css.icon> 
                {leadDetails.map(detail => (
                    <AutomatedLeadDetail key={detail} type={detail} lead={lead} />
                ))} 
            </css.wrapper>
            {isOpen &&  name===LEAD_TYPES.TICKDATA && (
                <TickdataCampaignsDetails isOpen={isOpen} onClose={close} showClass={showClass} />
            )}
            {isOpen && name===LEAD_TYPES.WHATSAPP_PROMOTION && (
                <WhatsappLeadDetails isOpen={isOpen} onClose={close} showClass={showClass}/>
            )}
            {isOpen && name===LEAD_TYPES.LIVE && (
                <LivePromotionDetails isOpen={isOpen} onClose={close} showClass={showClass}/>
            )}
        </>
    );
}

